import { FloatingAlertStore as TFloatingAlertStore } from 'foundations-components/transitional/components/FloatingAlertList/FloatingAlertStore';

// The UIComponents FloatingAlertStore is now just a proxy for the foundations-components FloatingAlertStore to allow for
// interoperability of FloatingAlertList between the two libraries during the Trellis migration.
const FloatingAlertStore = TFloatingAlertStore;
export default FloatingAlertStore;